import {useMemo} from "react";
import {useLocation} from "react-router-dom";

const VISIBLE_ROUTES = [
  "/dars",
  "/incidents",
  "/poolaccesslogs",
  "/dispatchlogs",
  "/property-inspection-reports",
  "/citations",
  "/stored-vehicles",
  "/safelistings",
  "/reportrequests",
];

/** Routes where the banner shows for the list and any nested path (e.g. detail pages). */
const VISIBLE_ROUTE_PREFIXES = ["/parking-enforcement", "/permanent-parking"];

export default function useIsPropertyBannerVisible() {
  const location = useLocation();

  return useMemo(() => {
    const p = location.pathname;
    if (VISIBLE_ROUTES.includes(p)) return true;
    return VISIBLE_ROUTE_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`));
  }, [location.pathname]);
}
